var map = {
  "./it_design-system.json": [
    "18154",
    "969"
  ],
  "./nl_design-system.json": [
    "44899",
    "590"
  ],
  "./pl_design-system.json": [
    "77106",
    "857"
  ],
  "./en_design-system.json": [
    "72525",
    "909"
  ],
  "./de_design-system.json": [
    "46618",
    "26"
  ],
  "./es_design-system.json": [
    "6830",
    "511"
  ],
  "./pt_design-system.json": [
    "80426",
    "722"
  ],
  "./fr_design-system.json": [
    "31596",
    "613"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 16539;
module.exports = webpackAsyncContext;
